import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import TableCell from '@material-ui/core/TableCell';
import Menu from '@material-ui/core/Menu/Menu';
import MenuItem from '@material-ui/core/MenuItem/MenuItem';
import Button from '@material-ui/core/Button/Button';
import ExpandMore from '@material-ui/icons/ExpandMore';

const ITEM_HEIGHT = 48;

class TableCellMenu extends Component {

  static propTypes = {
    onEdit: PropTypes.func,
    onDelete: PropTypes.func,
    onView: PropTypes.func,
  };

  static defaulProps = {
    onEdit: () => {},
    onDelete: () => {},
    onView: () => {},
  };

  constructor(props) {
    super(props);
    this.state = {
      anchorEl: null
    };
  }

  handleClick = (event) => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleClose = () => {
    this.setState({ anchorEl: null });
  };

  render() {
    const { anchorEl } = this.state;
    const { classes } = this.props;
    return(
      <TableCell align="right" className={classes.menu}>
        <Button className={classes.button} onClick={this.handleClick}>
          <ExpandMore />
        </Button>
        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={this.handleClose}
          PaperProps={{
            style: {
              maxHeight: ITEM_HEIGHT * 4.5,
              width: 200,
              boxShadow: 'none',
              borderRadius: '2px',
              border: '1px solid #E4E4E4'
            },
          }}>
          <MenuItem id="edit" onClick={this.props.onEdit}>
            Edit
          </MenuItem>
          <MenuItem  onClick={this.props.onDelete}>
            Delete
          </MenuItem>
          <MenuItem  onClick={this.props.onView}>
            View
          </MenuItem>
        </Menu>
      </TableCell>
    );	
  }  
}
const styles = {
  button: {
    padding: 0,
    width: 20,
    minWidth: 20,
  },
  menu: {
    width: 20,
    padding: 0,
    '&:last-child': {
      padding: 0
    }
  }
};

export default withStyles(styles)(TableCellMenu);
